'use client';

import { selectTenantFormAction } from '@/app/form-actions/auth';
import { TenantOptionDTO } from '@/services/dto/auth.dto';
import { useState } from 'react';
import { useFormState, useFormStatus } from 'react-dom';
import { FiArrowRight } from 'react-icons/fi';
import { CxButton } from '../atoms/CxButton';
import ErrorLabel from '../atoms/ErrorLabel';

function SubmitButton({ disabled }: { disabled: boolean }) {
  const status = useFormStatus();
  return <CxButton label="Continuar" type="submit" disabled={disabled} isLoading={status.pending} icon={<FiArrowRight className="text-gray-02" />} />;
}

export function TenantSelectionForm({ tenants }: { tenants: TenantOptionDTO[] }) {
  const [selected, setSelected] = useState('');
  const [state, formAction] = useFormState(selectTenantFormAction, {});

  return (
    <form action={formAction} className="flex flex-col gap-4">
      <div>
        <h1 className="font-bold text-lg">Selecione a conta</h1>
        <p className="text-sm text-gray-02">Escolha a conta que deseja acessar.</p>
      </div>
      {state?.error && <ErrorLabel>{state.error}</ErrorLabel>}
      <div className="flex flex-col gap-2">
        {tenants.map((tenant) => (
          <label key={tenant.id} className="flex cursor-pointer items-center gap-3 rounded border border-gray-03 p-3">
            <input type="radio" name="tenantId" value={tenant.id} checked={selected === tenant.id} onChange={() => setSelected(tenant.id)} />
            <strong>{tenant.name}</strong>
          </label>
        ))}
      </div>
      <SubmitButton disabled={!selected} />
    </form>
  );
}
